import React from 'react'

const Scopes = () => {
    return (
        <div>
            <h1 className='container'>Scopes of Variable</h1>
            <div className='container'>
                <p>A scope in any programming is a region of the program where a defined variable can have its existence and beyond that variable it cannot be accessed. There are three places where variables can be declared in C programming language − <br /></p>
                <ol>
                    <ul>Inside a function or a block which is called local variables</ul>
                    <ul>Outside of all functions which is called global variables.</ul>
                    <ul>In the definition of function parameters which are called formal parameters.</ul>

                </ol>
                <h3>Local Variables</h3>
                <p>
                Variables that are declared inside a function or block are called local variables.
                 They can be used only by statements that are inside that function or block of code.
                  Local variables are not known to functions outside their own. The following example
                   shows how local variables are used. Here all the variables a, b, and c are local to
                    main() function.
                </p>
                <div className='containers'>
                <code className='library'>#include</code>&lt;stdio.h&gt; <br/>
                <code className='keyword'>int </code>main()&#123;<br />
                <code className='comment'>/* local variable declaration */</code> <br />
                <code className='keywords'>int</code>{'  '}a,b,c <br />
                <code className='comment'>/* actual initalization*/</code><br />
                a=10; <br />
                b=20; <br />
                c= a+b; <br />
            <code className='keywords'>printf</code>('value of a = %d, b = %d and c = %d\n", a, b, c ') <br />
            return 0;<br />
                &#125;
                </div>
            </div>
            <div className='container'>
          <h3 >Global Variables</h3>
          <p>Global variables are defined outside a function, usually on top of the program. 
              Global variables hold their values throughout the lifetime of your program and they can be accessed inside any of the functions defined for the program.

A global variable can be accessed by any function. That is, a global variable is available for use throughout your entire program after its declaration. The following 
program show how global variables are used in a program.</p> <br />
  <div className='containers'>
  <code class="library">#include &lt;stdio.h&gt;</code> <br />
      <code className='comment'>/* global variable declaration */</code><br />
      <code className='keywords'>int</code>{' '}g; <br />
      <code className= 'keywords'>int</code> {' '}main() &#123;<br />
      <code className='comment'>/* local variable declaration*/</code><br />
      <code className='keywords'>int</code>{' '} a, b {' '},c; <br />
      <code className='comment'>/* actual initialization */</code> <br />
      a=10; <br />
      b=20; <br />
      g=a+b; <br />
      <code className='keywords'>printf</code> ("value of a = %d, b = %d and g = %d\n", a, b, g); <br />
     <code className='keywords'>return </code> 0; <br />
      &#125;
  </div>
  <h3>Initializing Local and Global Variables</h3>
  <p>When a local variable is defined, it is not initialized by the system, you must initialize it yourself. Global variables are initialized automatically by the system when you define them as follows −</p><br />
  <table style={{marginBottom:50}}>
  <thead>
    <tr>
      <th scope="col">Data Types</th>
      <th scope="col">Initial Default Value</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Data Types">int</td>
      <td data-label="Initial Default Value"> 0</td>
    </tr>
    <tr>
      <td scope="row" data-label="Data Types">char</td>
      <td data-label="Initial Default Value">0</td>
    </tr>
    <tr>
      <td scope="row" data-label="Data Types">float</td>
      <td data-label="Initial Default Value">'\0' mod</td>

    </tr>
    <tr>
      <td scope="row" data-label="Data Types">double</td>
      <td data-label="Initial Default Value">0</td>

    </tr>
    <tr>
      <td scope="row" data-label="Data Types">pointer</td>
      <td data-label="Initial Default Value"> NULL</td>
    </tr>
  
   
  </tbody>
</table>
  </div>
        </div>
    )
}

export default Scopes
